@if (group) {
  <div [formGroup]="group">
    <app-toogle [control]="group.controls['toogle']"></app-toogle>
    @if (group.controls['toogle'].value) {
      <div class="row">
        <div class="col-6">
          <app-text-box [control]="group.controls['userName']"></app-text-box>
        </div>
        <div class="col-6">
          <app-password [control]="group.controls['password']"></app-password>
        </div>
      </div>
    }
  </div>
}
